module.exports = __webpack_public_path__ + "static/img/default-logo.edcf48d9.jpg";